import React, { Component } from "react";
import "./SelectEngine.css";
import {
  LuRectangleHorizontal,
  LuRectangleVertical,
  LuSquare,
} from "react-icons/lu";
class SelectEngine extends Component {
  handleInput = (e) => {
    this.props.setEngine(e.target.value);
  };

  handleRatio = (e) => {
    const name = e.currentTarget.getAttribute("name");
    this.props.setAspectRatio(name);
  };

  handleQuality = (e) => {
    this.props.setEngine(e.target.value);
  };

  render() {
    let cost = 2;
    if (this.props.mode === "text") {
      if (this.props.engine === "1") cost = 2;
      if (this.props.engine === "2") cost = 3;
      if (this.props.engine === "3") cost = 6;
      // if (this.props.engine === "4") cost = 13;
      if (this.props.engine === "6") cost = 10;
    } else if (this.props.mode === "sketch") {
      cost = 1;
    } else if (this.props.mode === "inpaint") {
      cost = 1;
    } else if (this.props.mode === "scaller") {
      cost = 1;
    } else if (this.props.mode === "bgrem") {
      cost = 3;
    }
    const aspectRatio = this.props.aspectRatio;

    return (
      <div className="engine-container">
        <div
          style={{ color: this.props.mode !== "text" ? "#474747" : "white" }}
        >
          <label
            className="engine-label"
            style={{ fontWeight: "bolder", margin: 0 }}
          >
            {"Model:"}
          </label>

          <label
            className="engine-label"
            style={{
              fontWeight: this.props.engine === "1" ? "bolder" : "normal",
              maginLeft: 0,
            }}
          >
            <input
              disabled={this.props.mode !== "text"}
              type="radio"
              value="1"
              checked={this.props.engine === "1"}
              onChange={this.handleQuality}
              className="engine-input"
            />
            {"1.6"}
          </label>

          <label
            className="engine-label"
            style={{
              fontWeight: this.props.engine === "2" ? "bold" : "normal",
            }}
          >
            <input
              disabled={this.props.mode !== "text"}
              type="radio"
              value="2"
              checked={this.props.engine === "2"}
              onChange={this.handleQuality}
              className="engine-input"
            />
            {"XL"}
          </label>

          <label
            className="engine-label"
            style={{
              fontWeight: this.props.engine === "3" ? "bold" : "normal",
            }}
          >
            <input
              disabled={this.props.mode !== "text"}
              type="radio"
              value="3"
              checked={this.props.engine === "3"}
              onChange={this.handleQuality}
              className="engine-input"
            />
            {"Core"}
          </label>

          <label
            className="engine-label"
            style={{
              fontWeight: this.props.engine === "6" ? "bold" : "normal",
            }}
          >
            <input
              disabled={this.props.mode !== "text"}
              type="radio"
              value="6"
              checked={this.props.engine === "6"}
              onChange={this.handleQuality}
              className="engine-input"
            />
            {"Ultra"}
          </label>
        </div>
        <div>
          <label className="engine-cost-label"> {`${cost} Cred`}</label>

          {this.props.mode === "text" && (
            <div className="ratio-dropdown">
              {aspectRatio === "square" && (
                <LuSquare className="react-icons" size={25} />
              )}
              {aspectRatio === "portrait" && (
                <LuRectangleVertical className="react-icons" size={25} />
              )}
              {aspectRatio === "landscape" && (
                <LuRectangleHorizontal className="react-icons" size={25} />
              )}
              <div className="ratio-dropdown-content">
                <div
                  className="ratio-dropdown-item"
                  name="square"
                  onClick={this.handleRatio}
                >
                  <p>
                    <LuSquare className="react-icons" size={25} />
                  </p>
                </div>
                <div
                  className="ratio-dropdown-item"
                  name="portrait"
                  onClick={this.handleRatio}
                >
                  <p>
                    <LuRectangleVertical className="react-icons" size={25} />
                  </p>
                </div>
                <div
                  className="ratio-dropdown-item"
                  name="landscape"
                  onClick={this.handleRatio}
                >
                  <p>
                    <LuRectangleHorizontal className="react-icons" size={25} />
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default SelectEngine;
